export default {"src":"/_next/static/media/c2c-introduction-mobile.2921f0f1.svg","height":450,"width":398,"blurWidth":0,"blurHeight":0};